import { Text } from '@hotjar/hotsauce';
import {
  StyledHeaderEmptyState,
  StyledEmptyStateIllustration,
  StyledEmptyStateTextContainer,
} from '../styles';

type Props = {
  image?: string;
  color: string;
  title: string;
  description: string;
};

export const WidgetEmptyState = ({ image, color, title, description }: Props) => {
  return (
    <>
      <StyledHeaderEmptyState>
        <Text as="h2" textType="header5">
          {title}
        </Text>
      </StyledHeaderEmptyState>
      {image && <StyledEmptyStateIllustration image={image} color={color} />}
      <StyledEmptyStateTextContainer>
        <Text textColor="text_light" textType="body2">
          {description}
        </Text>
      </StyledEmptyStateTextContainer>
    </>
  );
};
